import React, { useState } from "react";
import Button from "../../components/Button/Button";
import "./Login.css";
import { useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import { IoArrowBack } from "react-icons/io5";
import { login } from "../../hooks/useAuth";
import { useTranslation } from 'react-i18next';
import { fetchCurrentUser } from "../../store/user";
import { AppDispatch } from "../../store";
import { useDispatch } from "react-redux";


const Login = () => {
  const { register, handleSubmit } = useForm();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');
  const [stayLoggedIn, setStayLoggedIn] = useState(false);
  const dispatch = useDispatch<AppDispatch>();

  const { t } = useTranslation();

  const onSubmit = async (data) => {
    try {
      await login(data.username, data.password, stayLoggedIn);
      dispatch(fetchCurrentUser());
      navigate('/loading');
    } catch (error) {
      if (error instanceof Error) {
        setErrorMessage(error.message);
      } else {
        setErrorMessage("Login failed. Please try again.");
      }
    }
  };

  return (
    <form className="form-wrapper-login login" onSubmit={handleSubmit(onSubmit)}>
      <button
        type="button"
        className="back-button"
        onClick={() => navigate('/welcome')}
      >
        <IoArrowBack size={20} /> Back
      </button>

      <h2 className="header-medium">Login with Email</h2>
      <p className="bread bread-text">Email and password are required to log in</p>

      {errorMessage && <div className="error">{errorMessage}</div>}

      <div className="data-input-wrapper">
        <div className="input-wrapper">
            <input 
              type="text" 
              id="username" 
              placeholder={t('loginIndex.email.label', 'Email address')}
              {...register('username', { required: true })} 
            />
          </div>
        <div className="input-wrapper">
          <input
            type="password" 
            id="password" 
            placeholder="Password" 
            {...register('password', { required: true })} />
        </div>
        <div className="input-wrapper stay-logged-in">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={stayLoggedIn}
              onChange={(e) => setStayLoggedIn(e.target.checked)}
            />
            Stay logged in
          </label>
        </div>
      </div>

      <div className="login-button-wrapper">
        <Button
          primary={true}
          label="Log in"
          backgroundColor="var(--color-secondary)"
          size=""
        />
      </div>
    </form>
  );
};

export default Login;
